const Alert = ({
   color,
   children
}) => {
   var bg = color
   return (
      <div className={`alert alert-${bg}`}>
         {children}
      </div>
   )
} 
export default Alert